import { render, staticRenderFns } from "./BoxCaseForm.vue?vue&type=template&id=65530e04&scoped=true&"
import script from "./BoxCaseForm.vue?vue&type=script&lang=ts&"
export * from "./BoxCaseForm.vue?vue&type=script&lang=ts&"
import style0 from "./BoxCaseForm.vue?vue&type=style&index=0&id=65530e04&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65530e04",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CustomTooltip: require('C:/inetpub/wwwroot/bike-flights/components/CustomTooltip.vue').default})
